/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigResponse,
  ShareRequestBody,
} from '../models/index';
import {
    ConfigResponseFromJSON,
    ConfigResponseToJSON,
    ShareRequestBodyFromJSON,
    ShareRequestBodyToJSON,
} from '../models/index';

export interface AddShareWithRequest {
    shareRequestBody: ShareRequestBody;
}

export interface DeleteShareByRequest {
    requestBody: { [key: string]: number; };
}

export interface DeleteShareWithRequest {
    shareRequestBody: ShareRequestBody;
}

export interface GetUsersSharedByHierarchyRequest {
    apiKey: string;
}

export interface GetUsersSharedWithHierarchyRequest {
    apiKey: string;
}

/**
 * 
 */
export class PublistShareApi extends runtime.BaseAPI {

    /**
     * Creates request options for addShareWith without sending the request
     */
    async addShareWithRequestOpts(requestParameters: AddShareWithRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shareRequestBody'] == null) {
            throw new runtime.RequiredError(
                'shareRequestBody',
                'Required parameter "shareRequestBody" was null or undefined when calling addShareWith().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/share/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShareRequestBodyToJSON(requestParameters['shareRequestBody']),
        };
    }

    /**
     */
    async addShareWithRaw(requestParameters: AddShareWithRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConfigResponse>>> {
        const requestOptions = await this.addShareWithRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConfigResponseFromJSON));
    }

    /**
     */
    async addShareWith(requestParameters: AddShareWithRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConfigResponse>> {
        const response = await this.addShareWithRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteShareBy without sending the request
     */
    async deleteShareByRequestOpts(requestParameters: DeleteShareByRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deleteShareBy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/share/by`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async deleteShareByRaw(requestParameters: DeleteShareByRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteShareByRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteShareBy(requestParameters: DeleteShareByRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteShareByRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteShareWith without sending the request
     */
    async deleteShareWithRequestOpts(requestParameters: DeleteShareWithRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['shareRequestBody'] == null) {
            throw new runtime.RequiredError(
                'shareRequestBody',
                'Required parameter "shareRequestBody" was null or undefined when calling deleteShareWith().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/share/with`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ShareRequestBodyToJSON(requestParameters['shareRequestBody']),
        };
    }

    /**
     */
    async deleteShareWithRaw(requestParameters: DeleteShareWithRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConfigResponse>>> {
        const requestOptions = await this.deleteShareWithRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConfigResponseFromJSON));
    }

    /**
     */
    async deleteShareWith(requestParameters: DeleteShareWithRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConfigResponse>> {
        const response = await this.deleteShareWithRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUsersSharedByHierarchy without sending the request
     */
    async getUsersSharedByHierarchyRequestOpts(requestParameters: GetUsersSharedByHierarchyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling getUsersSharedByHierarchy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/share/{apiKey}/by/hierarchy`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUsersSharedByHierarchyRaw(requestParameters: GetUsersSharedByHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        const requestOptions = await this.getUsersSharedByHierarchyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getUsersSharedByHierarchy(requestParameters: GetUsersSharedByHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.getUsersSharedByHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUsersSharedWithHierarchy without sending the request
     */
    async getUsersSharedWithHierarchyRequestOpts(requestParameters: GetUsersSharedWithHierarchyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['apiKey'] == null) {
            throw new runtime.RequiredError(
                'apiKey',
                'Required parameter "apiKey" was null or undefined when calling getUsersSharedWithHierarchy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            queryParameters["apikey"] = await this.configuration.apiKey("apikey"); // APIKeyAuthRequestParam authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["APIKey"] = await this.configuration.apiKey("APIKey"); // APIKeyAuthHeader authentication
        }


        let urlPath = `/publist/share/{apiKey}/with/hierarchy`;
        urlPath = urlPath.replace(`{${"apiKey"}}`, encodeURIComponent(String(requestParameters['apiKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getUsersSharedWithHierarchyRaw(requestParameters: GetUsersSharedWithHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Array<number>>>> {
        const requestOptions = await this.getUsersSharedWithHierarchyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getUsersSharedWithHierarchy(requestParameters: GetUsersSharedWithHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Array<number>>> {
        const response = await this.getUsersSharedWithHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
